import times from 'lodash/times';
import React from 'react';
import { Shimmer } from '../../../../../../../CommonComponents/OPL/Shimmer/Shimmer';
import { TableCell, TableRow } from '../../../../../../../CommonComponents/OPL/Table/Table';
import { UnrealizedGainLossDetailsSkeleton } from './UnrealizedGainLossDetailsSkeleton';
import { useIsEmbeddedMobile } from '../../../../../../../_hooks/useIsEmbeddedMobile';

interface Props {
  title: string;
}

export const UnrealizedGainLossDetailsLoading = ({ title }: Props) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  return (
    <UnrealizedGainLossDetailsSkeleton title={title}>
      {times(7).map(i => (
        <TableRow key={i}>
          <TableCell width="40%">
            <Shimmer width="100%" height={20} />
          </TableCell>

          {times(isEmbeddedMobile ? 1 : 11).map(j => (
            <TableCell key={j} width="10%">
              <Shimmer width="100%" height={20} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </UnrealizedGainLossDetailsSkeleton>
  );
};
